import { persist } from 'zustand/middleware';
import { create } from 'zustand';
import { Page } from 'components/Onboarding/Onboarding.types';

interface OnBoardingState {
  completedPages: Page[];
  addPage: (page: Page) => void;
}

const useOnboarding = create<OnBoardingState>()(
  persist(
    (set) => ({
      completedPages: [],
      addPage: (page) =>
        set((prevState) => ({
          ...prevState,
          completedPages: [...prevState.completedPages, page],
        })),
    }),
    {
      name: 'onboarding',
    },
  ),
);

export default useOnboarding;
